import { Layout, util } from '@glu/core';
import template from './rowSubViewWrapper.hbs';

export default Layout.extend({
  tagName: 'tr',
  className: 'grid-subrow hidden',

  regions: {
    subrow: '.js-region-grid-subrow'
  },

  template,

  onRender() {
    this.showRowSubView();
  },

  showRowSubView() {
    this.subRowView = new this.options.RowSubView(util.extend({}, (this.options.rowSubViewOptions || {}), {
      model: this.model
    }));

    this.subrow.show(this.subRowView);
  },

  onSubRowExpanded() {
    if (this.subRowView) {
      this.subRowView.triggerMethod('subRowExpanded');
    }
  }
});
